import type { SVGProps } from 'react';
const SvgFlashOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#flash_on_svg__a)">
      <path fill="currentColor" d="M7 2v11h3v9l7-12h-4l4-8H7Z" />
    </g>
    <defs>
      <clipPath id="flash_on_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFlashOn;
